angular.module('gym.components').directive('reportBooleanFilter', function() {
  return {
    restrict: 'E',
    template: require('templates/components/reports/report_boolean_filter.html.slim')
  };
});
